export default __webpack_public_path__ + "static/media/downArrowDropdown.47177f76.svg";